import React, { ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

const HeaderLineStyled = styled.div`
  border-bottom: 1px solid lightgray;
  flex: 1 1 auto;
  position: relative;
  transform: translateY(-50%);
  top: 0.5px;
`;

const HeaderWithLine: React.FC<{ children: ReactNode; style?: CSSProperties }> = ({ children, style }) => (
  <div className='gx-d-flex gx-position-relative' style={style}>
    <div className='mr-5 flex items-center'>{children}</div>
    <HeaderLineStyled />
  </div>
);

export default React.memo(HeaderWithLine);
